import { el, mount, unmount } from 'redom';

import { stringToSVG } from 'utilities';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import FilterPanelContent, { filterTypes } from './content';

import './index.scss';

import filterPanelIconString from 'assets/images/filter-panel-icon.svg?raw';

const filterPanelIcon = stringToSVG(filterPanelIconString);

class FilterPanel {

  constructor(configuration) {

    this.displayed = false;
    this.configuration = configuration;

    this.panel = this.renderPanel();
    this.button = this.renderButton();

    this.el = el('.filter-panel-main', {
      onclick: this.handleClick.bind(this)
    }, [
      el('x-tooltip', {
        text: 'Advanced options'
      }, [this.button])
    ]);

  }

  handleMouseEnter() {

    mount(this.el, this.panel);

    const element = this.panel.el;
    const anchorElement = this.button;
    const viewportElement = void 0;
    const verticalOffset = 0;
    const horizontalOffset = 0;
    const startSide = 'left';
    const placeOnCenter = true;
    const positionableSides = ['left', 'right'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  handleClick() {

    if (this.displayed === true) {
      return;
    }

    this.displayed = true;
    this.handleMouseEnter();
    this.configuration.onActive();

  }

  handlePanelClose() {

    unmount(this.el, this.panel);
    this.configuration.onInactive();
    this.displayed = false;

  }

  renderPanel() {

    const panel = new FilterPanelContent({
      filter: this.configuration.filter,
      onClose: this.handlePanelClose.bind(this)
    });

    return panel;

  }

  renderButton() {

    return el('button.filter-panel-control', {}, [filterPanelIcon.cloneNode(true)]);

  }

}

export { filterTypes };

export default FilterPanel;